import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RidesPage = lazy(() => import('../pages/rides/page'));
const BeartoothPassPage = lazy(() => import('../pages/rides/beartooth-pass/page'));
const MillionDollarHighwayPage = lazy(() => import('../pages/rides/million-dollar-highway/page'));
const GoingToTheSunRoadPage = lazy(() => import('../pages/rides/going-to-the-sun-road/page'));
const ChiefJosephBywayPage = lazy(() => import('../pages/rides/chief-joseph-byway/page'));
const DivesPage = lazy(() => import('../pages/dives/page'));
const TheMintBarPage = lazy(() => import('../pages/dives/the-mint-bar/page'));
const OwlClubPage = lazy(() => import('../pages/dives/owl-club/page'));
const SilverDollarBarPage = lazy(() => import('../pages/dives/silver-dollar-bar/page'));
const TheBuckhornBarPage = lazy(() => import('../pages/dives/the-buckhorn-bar/page'));
const MurrayBarPage = lazy(() => import('../pages/dives/murray-bar/page'));
const TheWortHotelBarPage = lazy(() => import('../pages/dives/the-wort-hotel-bar/page'));
const TheAntlersInnPage = lazy(() => import('../pages/dives/the-antlers-inn/page'));
const TheStockmanBarPage = lazy(() => import('../pages/dives/the-stockman-bar/page'));
const ThePastimeBarPage = lazy(() => import('../pages/dives/the-pastime-bar/page'));
const TheShootingStarPage = lazy(() => import('../pages/dives/the-shooting-star/page'));
const GearPage = lazy(() => import('../pages/gear/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TripPlannerPage = lazy(() => import('../pages/trip-planner/page'));
const MerchPage = lazy(() => import('../pages/merch/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const FollowPage = lazy(() => import('../pages/follow/page'));
const ClassicHoodiePage = lazy(() => import('../pages/merch/classic-hoodie/page'));
const MountainRoadsTeePage = lazy(() => import('../pages/merch/mountain-roads-tee/page'));
const DiveBarSnapbackPage = lazy(() => import('../pages/merch/dive-bar-snapback/page'));
const StickerPackPage = lazy(() => import('../pages/merch/sticker-pack/page'));
const YetiTumblerPage = lazy(() => import('../pages/merch/yeti-tumbler/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const PartnersDirectoryPage = lazy(() => import('../pages/partners-directory/page'));
const PartnersAdminPage = lazy(() => import('../pages/admin/partners/page'));
const RewardsPage = lazy(() => import('../pages/rewards/page'));
const RewardsDashboardPage = lazy(() => import('../pages/rewards/dashboard/page'));
const QRLandingPage = lazy(() => import('../pages/qr/page'));
const TermsOfServicePage = lazy(() => import('../pages/tos/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/rewards',
    element: <RewardsPage />,
  },
  {
    path: '/rewards/dashboard',
    element: <RewardsDashboardPage />,
  },
  {
    path: '/qr',
    element: <QRLandingPage />,
  },
  {
    path: '/rides',
    element: <RidesPage />,
  },
  {
    path: '/rides/beartooth-pass',
    element: <BeartoothPassPage />,
  },
  {
    path: '/rides/million-dollar-highway',
    element: <MillionDollarHighwayPage />,
  },
  {
    path: '/rides/going-to-the-sun-road',
    element: <GoingToTheSunRoadPage />,
  },
  {
    path: '/rides/chief-joseph-byway',
    element: <ChiefJosephBywayPage />,
  },
  {
    path: '/dives',
    element: <DivesPage />,
  },
  {
    path: '/dives/the-mint-bar',
    element: <TheMintBarPage />,
  },
  {
    path: '/dives/owl-club',
    element: <OwlClubPage />,
  },
  {
    path: '/dives/silver-dollar-bar',
    element: <SilverDollarBarPage />,
  },
  {
    path: '/dives/the-buckhorn-bar',
    element: <TheBuckhornBarPage />,
  },
  {
    path: '/dives/murray-bar',
    element: <MurrayBarPage />,
  },
  {
    path: '/dives/the-wort-hotel-bar',
    element: <TheWortHotelBarPage />,
  },
  {
    path: '/dives/the-antlers-inn',
    element: <TheAntlersInnPage />,
  },
  {
    path: '/dives/the-stockman-bar',
    element: <TheStockmanBarPage />,
  },
  {
    path: '/dives/the-pastime-bar',
    element: <ThePastimeBarPage />,
  },
  {
    path: '/dives/the-shooting-star',
    element: <TheShootingStarPage />,
  },
  {
    path: '/gear',
    element: <GearPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/tos',
    element: <TermsOfServicePage />,
  },
  {
    path: '/trip-planner',
    element: <TripPlannerPage />,
  },
  {
    path: '/merch',
    element: <MerchPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/partners-directory',
    element: <PartnersDirectoryPage />,
  },
  {
    path: '/admin/partners',
    element: <PartnersAdminPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/follow',
    element: <FollowPage />,
  },
  {
    path: '/merch/classic-hoodie',
    element: <ClassicHoodiePage />,
  },
  {
    path: '/merch/mountain-roads-tee',
    element: <MountainRoadsTeePage />,
  },
  {
    path: '/merch/dive-bar-snapback',
    element: <DiveBarSnapbackPage />,
  },
  {
    path: '/merch/sticker-pack',
    element: <StickerPackPage />,
  },
  {
    path: '/merch/yeti-tumbler',
    element: <YetiTumblerPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
